import { AvailableRoutes } from '@/router/Routes.ts';

type ExtractRouteParams<T extends string> = string extends T
  ? Record<string, string>
  : // eslint-disable-next-line @typescript-eslint/no-unused-vars
    T extends `${infer _Start}:${infer Param}/${infer Rest}`
    ? { [k in Param | keyof ExtractRouteParams<`/${Rest}`>]: string }
    : // eslint-disable-next-line @typescript-eslint/no-unused-vars
      T extends `${infer _Start}:${infer Param}`
      ? { [k in Param]: string }
      : never;

export function passToRoute<T extends AvailableRoutes>(route: T, params: ExtractRouteParams<T>) {
  let url: string = route;
  Object.entries(params).forEach(([key, value]) => {
    url = url.replace(`:${key}`, value);
  });

  return url;
}
